import { Box, Col, Row } from '@opendoor/bricks-next';

import articleEntryLookup from '../../cms/entries/articleV2';
import type { EntryComponent } from '../../cms/entries/entries';
import RichTextRenderer from '../../cms/renderer';
import renderAsset from '../../cms/renderer/assets';
import type { IComponentHighlightBox } from '../../declarations/contentful';

const variantStyles = {
  default: {},
  leftBorder: { borderLeft: '3px solid #ddd' },
  dropShadow: {
    boxShadow: '0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)',
  },
};

const variantBgColor = {
  default: '$backgroundTertiary',
  leftBorder: '$backgroundTertiary',
  dropShadow: '$backgroundPrimary',
} as const;

const renderHighlightBox = (entry: IComponentHighlightBox) => {
  const { fields } = entry;

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <Row
        backgroundColor={variantBgColor[fields.variant] ?? variantBgColor.default}
        borderRadius="$8x"
        my="$20x"
        p="$12x"
        flexWrap="wrap"
        gap="$10x"
        $largerThanXS={{ p: '$24x' }}
        $platform-web={variantStyles[fields.variant] ?? variantStyles.default}
      >
        {fields.image && (
          <Col
            width={fields.image.fields.file?.details?.image?.width ?? 200}
            maxWidth="100%"
            alignSelf="center"
            $largerThanXS={{ maxWidth: '50%' }}
            $platform-web={{ height: 'auto' }}
          >
            {renderAsset({
              src: fields.image.fields.file?.url,
              contentType: fields.image.fields.file?.contentType || 'image/png',
              width: fields.image.fields.file?.details?.image?.width ?? 200,
              height: fields.image.fields.file?.details?.image?.height ?? 200,
            })}
          </Col>
        )}
        {fields.content && (
          <Col alignItems="flex-start" flex={1}>
            <RichTextRenderer.Component
              body={fields.content}
              idToLoaderData={{}}
              entryLookup={articleEntryLookup}
            />
          </Col>
        )}
      </Row>
    </Box>
  );
};

const HighlightBox: EntryComponent<IComponentHighlightBox> = {
  render: renderHighlightBox,
};

export default HighlightBox;
